var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "characteristic-edit" }, [
      _vm.selected && _vm.selected.length > 0
        ? _c(
            "div",
            { staticClass: "characteristic-edit--selected-items" },
            [
              _c("SelectedItems", {
                staticClass: "no-left-padding",
                attrs: {
                  "characteristic-items": _vm.characteristicItems,
                  "characteristic-type": _vm.characteristicType,
                  selected: _vm.selectedItems,
                  "show-experience": _vm.selectedItemsConfig
                    ? _vm.selectedItemsConfig.showExperience
                    : undefined,
                  flat: _vm.selectedItemsConfig
                    ? _vm.selectedItemsConfig.flat
                    : undefined,
                  "icon-path": _vm.iconPath,
                  "no-children-appendix": _vm.selectedItemsConfig
                    ? _vm.selectedItemsConfig.noChildrenAppendix
                    : undefined,
                  "label-type": _vm.selectedItemsConfig
                    ? _vm.selectedItemsConfig.labelType
                    : undefined,
                  styling: _vm.selectedItemsConfig
                    ? _vm.selectedItemsConfig.styling
                    : undefined,
                  "sort-type": _vm.selectedItemsConfig
                    ? _vm.selectedItemsConfig.sortType
                    : undefined
                },
                on: { click: _vm.openFan }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.nothingAllowed &&
      _vm.nothingAllowed.overall &&
      !_vm.nothingAllowed.overall.inFan &&
      !_vm.hasSelectedItems
        ? _c(
            "div",
            { staticClass: "overall" },
            [
              _c(
                "b-form-checkbox",
                {
                  on: { input: _vm.nothingAllowedOverallChanged },
                  model: {
                    value: _vm.nothingAllowedOverall,
                    callback: function($$v) {
                      _vm.nothingAllowedOverall = $$v
                    },
                    expression: "nothingAllowedOverall"
                  }
                },
                [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.nothingAllowed.overall.text) +
                      "\n\t\t\t"
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showNothingAllowedOverallInfo
        ? _c("div", { staticClass: "overall-info" }, [
            _vm._v(_vm._s(_vm.nothingAllowed.overall.text))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.withEditButton
        ? _c(
            "div",
            { class: "text-" + _vm.openFanButtonAlignment },
            [
              !_vm.nothingAllowedOverall || _vm.isNothingAllowedOverallInFan
                ? _c("Button", {
                    attrs: {
                      text: _vm.computedOpenFanLabel,
                      secondary: "",
                      smaller: ""
                    },
                    on: { click: _vm.openFan }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }